/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { TaskCheckpointResourceService } from '@well/delivery-libs/task-management/resource-services';

@Injectable({providedIn: 'root'})
export class TaskCardSummaryService {

  private readonly taskCheckpointResourceService = inject(TaskCheckpointResourceService);

  unavailable(uuid: string){
    return this.taskCheckpointResourceService.unavailable(uuid);
  }
}
